<button
    type="button"
    class="anc-fc-pill"
    [class.anc-fc-pill--size-default]="size === 'default'"
    [class.anc-fc-pill--size-compact]="size === 'compact'"
    [class.anc-fc-pill--size-mini]="size === 'mini'"
    [class.anc-fc-pill--applied]="applied"
    [class.anc-fc-pill--open]="popoverOpen"
    [class.anc-fc-pill--disabled]="disabled"
    [disabled]="disabled"
    [ngbPopover]="chip.type === 'toggle' ? null : popoverTpl"
    [autoClose]="'outside'"
    [placement]="placement"
    container="body"
    [popoverClass]="chip.type === 'date-range' ? 'anc-fc-popover anc-fc-popover--date' : 'anc-fc-popover'"
    #chipPopover="ngbPopover"
    (shown)="onPopoverShown()"
    (hidden)="onPopoverHidden()"
    (click)="onClick()"
>
    <span *ngIf="chip.leftIcon" class="anc-fc-icon icon {{ chip.leftIcon }}" aria-hidden="true"></span>
    <span class="anc-fc-label">
        <ng-container *ngIf="applied && chip.formatValue; else translatedChipLabel">
            {{ displayLabel }}
        </ng-container>
        <ng-template #translatedChipLabel>
            <span translate>{{ chip.label }}</span><ng-container *ngIf="applied && isMultiValue"> · {{ value.length }}</ng-container>
        </ng-template>
    </span>
    <span
        *ngIf="chip.clearable && applied"
        class="anc-fc-clear icon icon-x"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Clear' | translate"
        (click)="onClearClick($event)"
        (keydown.enter)="onClearClick($event)"
        (keydown.space)="onClearClick($event)"
    ></span>
    <span *ngIf="showCaret" class="anc-fc-caret icon icon-chevron-down" aria-hidden="true"></span>
</button>

<ng-template #popoverTpl>
    <div class="anc-fc-pop" [class.anc-fc-pop--date]="chip.type === 'date-range'">
        <!-- Search -->
        <input
            *ngIf="chip.searchable"
            type="text"
            class="anc-fc-pop-search form-control"
            [placeholder]="('Search' | translate) + ' ' + (chip.label | translate)"
            [(ngModel)]="searchTerm"
        />

        <!-- Loading -->
        <div *ngIf="optionsLoading" class="anc-fc-pop-loading">
            <span class="icon icon-loader"></span>
            <span translate>Loading…</span>
        </div>

        <!-- Multi-select list -->
        <ng-container *ngIf="chip.type === 'multi-select' && !optionsLoading">
            <ul class="dropdown-menu anc-action-menu show" role="listbox" aria-multiselectable="true">
                <li
                    *ngFor="let opt of visibleOptions"
                    class="dropdown-item"
                    role="option"
                    [attr.aria-selected]="isDraftSelected(opt)"
                    (click)="toggleDraft(opt)"
                >
                    <input
                        type="checkbox"
                        [checked]="isDraftSelected(opt)"
                        (click)="$event.stopPropagation()"
                        (change)="toggleDraft(opt)"
                    />
                    <span class="anc-fc-pop-item-label">{{ opt.label | translate }}</span>
                </li>
            </ul>
            <div *ngIf="visibleOptions.length === 0" class="anc-fc-pop-empty" translate>
                No options
            </div>

            <div class="anc-fc-pop-footer">
                <button
                    type="button"
                    libAncButton
                    variant="tertiary"
                    size="small"
                    class="anc-fc-pop-clear"
                    (click)="clearDraft()"
                >
                    <span translate>Clear</span>
                </button>
                <button
                    type="button"
                    libAncButton
                    variant="primary"
                    size="small"
                    class="anc-fc-pop-apply"
                    (click)="applyDraft()"
                >
                    <span translate>Apply</span>
                </button>
            </div>
        </ng-container>

        <!-- Single-select list -->
        <ng-container *ngIf="chip.type === 'select' && !optionsLoading">
            <ul class="dropdown-menu anc-action-menu show" role="listbox">
                <li
                    *ngFor="let opt of visibleOptions"
                    class="dropdown-item"
                    role="option"
                    [attr.aria-selected]="value?.id === opt.id"
                    (click)="selectSingle(opt)"
                >
                    {{ opt.label | translate }}
                </li>
            </ul>
            <div *ngIf="visibleOptions.length === 0" class="anc-fc-pop-empty" translate>
                No options
            </div>
        </ng-container>

        <!-- Date range -->
        <ng-container *ngIf="chip.type === 'date-range'">
            <app-anc-date-range
                [value]="value"
                (valueChange)="onDateRangeChange($event)"
            ></app-anc-date-range>
        </ng-container>
    </div>
</ng-template>
